import React, { useEffect, useState } from "react"
import { Link as RouterLink } from "react-router-dom"
import { providerFinderRootPath } from "../../utils/providerFinderSearchUrl"
import { getHeap } from "../../utils/heap"
import { defineMessage, FormattedMessage } from "react-intl"
import { Box, Button, Link, Typography } from "@carrotfertility/carotene-core"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { RecommendDoulaDialog } from "#/pages/provider-finder/recommend-doula/RecommendDoulaDialog"

export function DoulaNoResultDisplay({ isCountryCodeNotMatching }: { isCountryCodeNotMatching: boolean }): JSX.Element {
  const { mutate: trackMemberAction } = useMemberActionTracking()
  const [openRecommendDoulaDialog, setOpenRecommendDoulaDialog] = useState(false)

  useEffect(
    function trackDoulaSearchNoResultsMessageRendered() {
      getHeap().track("Doula Search No Results Message Rendered", {
        "Location Is Outside Country": isCountryCodeNotMatching ? "true" : "false"
      })
    },
    [isCountryCodeNotMatching]
  )

  const headerMessage = defineMessage({ defaultMessage: "No results in Provider finder, but..." })

  return (
    <Box display="flex" justifyContent="center" width="100%">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="22.6875rem"
        gap={(theme) => theme.tokens.spacing.md}
      >
        <Box
          component="img"
          src={"/images/search.png"}
          srcSet={"/images/search-2x.png"}
          alt=""
          sx={{ inlineSize: "4.25rem", blockSize: "4.25rem" }}
        />
        <Box textAlign="center" gap={(theme) => theme.tokens.spacing.xs}>
          <Typography variant="h4" color="secondary">
            <FormattedMessage {...headerMessage} />
          </Typography>
          <Typography variant="body1" color="secondary">
            <FormattedMessage defaultMessage="We add new providers all the time. You can recommend a doula to help us grow our network." />
          </Typography>
        </Box>
        <Box display="flex" gap={(theme) => theme.tokens.spacing.xs}>
          <Button component={RouterLink} to={providerFinderRootPath} variant="outlined" color="secondary" size="medium">
            <FormattedMessage defaultMessage="Search again" />
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setOpenRecommendDoulaDialog(true)
              trackMemberAction({
                memberActionTaken: MemberActions.PROVIDER_FINDER_RECOMMEND_A_DOULA_OPENED,
                metaData: {
                  location: `Provider Finder Doula No Results Display`
                }
              })
            }}
          >
            <FormattedMessage defaultMessage="Recommend a doula" />
          </Button>
        </Box>
        <Typography variant="body1" color="secondary" textAlign="center">
          <FormattedMessage
            defaultMessage="Still having trouble? <Link>Contact us</Link>."
            values={{
              Link: (textLinkContent) => (
                <Link component={RouterLink} color="inherit" to="/talk-to-carrot/sendmessage/helpfindingdoula">
                  {textLinkContent}
                </Link>
              )
            }}
          />
        </Typography>
      </Box>
      <RecommendDoulaDialog open={openRecommendDoulaDialog} onClose={() => setOpenRecommendDoulaDialog(false)} />
    </Box>
  )
}
